module.exports = __webpack_public_path__ + "img/mail.e047cc78.svg";